import styled from 'styled-components';

export const FieldsContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-top: 15px;

  h5 {
    color: #32325d;
    font-weight: 600;
    border-bottom: 2px solid #5e72e4;
    padding-bottom: 8px;
    margin-bottom: 15px;
  }
`;

export const FieldItem = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid #f6f9fc;

  &:last-child {
    border-bottom: none;
  }

  label {
    margin-bottom: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 14px;

    input[type='checkbox'] {
      margin-right: 10px;
      cursor: pointer;
      width: 18px;
      height: 18px;
    }
  }

  &:hover {
    background-color: #f6f9fc;
  }
`;

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f6f9fc;
  border-radius: 4px;

  button {
    margin-right: 10px;
  }

  span {
    color: #32325d;
    font-size: 14px;
  }
`;
